import { render } from "./Isolated.vue?vue&type=template&id=4df9a010"
import script from "./Isolated.vue?vue&type=script&lang=js"
export * from "./Isolated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__